import { useRecord } from "./useRecord";

export function useThreadTimelineEntry(props: { timelineId?: string | null }) {
  return useRecord("thread_timeline", props.timelineId, { name: "useThreadTimelineEntry" });
}
